module.exports = __webpack_public_path__ + "img/Mail.6558aa28.svg";